import React from 'react';
import { auth } from '../firebase';
import { signOut } from 'firebase/auth';
import { User, Mail, LogOut } from 'lucide-react';
import './Profile.css';

const Profile = ({ isAdmin = false }) => {
  const user = auth.currentUser;

  const handleSignOut = async () => {
    try {
      await signOut(auth);
    } catch (err) {
      console.error('Sign out error:', err);
    }
  };

  return (
    <div className="profile-container">
      <div className="section-header">
        <h1>Profile</h1>
        <p>Your account information</p>
      </div>
      <div className="profile-card">
        <div className="profile-avatar">
          {isAdmin && user?.photoURL ? (
            <img src={user.photoURL} alt={user.displayName || user.email} />
          ) : (
            <User size={48} />
          )}
        </div>
        <div className="profile-details">
          <div className="profile-row">
            <Mail size={18} className="profile-icon" />
            <span className="profile-label">Email</span>
            <span className="profile-value">{user?.email || 'Not signed in (preview)'}</span>
          </div>
          {user?.displayName && (
            <div className="profile-row">
              <User size={18} className="profile-icon" />
              <span className="profile-label">Display Name</span>
              <span className="profile-value">{user.displayName}</span>
            </div>
          )}
          {!user && (
            <div className="profile-row">
              <User size={18} className="profile-icon" />
              <span className="profile-label">Role</span>
              <span className="profile-value">{isAdmin ? 'Admin (preview)' : 'Preview'}</span>
            </div>
          )}
        </div>
        {user ? (
          <button type="button" className="profile-signout-btn" onClick={handleSignOut}>
            <LogOut size={18} />
            Sign Out
          </button>
        ) : (
          <p className="profile-preview-note">Sign in to manage your real account.</p>
        )}
      </div>
    </div>
  );
};

export default Profile;
